import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import FavoriteCocktails from "../components/FavoriteCocktails";

const Favorites = () => {
  return (
    <div>
      <Navbar />
      <Hero title={"Favorites"} />
      <FavoriteCocktails />
      <Footer />
    </div>
  );
};

export default Favorites;
